import React from 'react';
import FirstScreen from './screens/FirstScreen'
import SuccessScreen from './screens/SuccessScreen'
import ErrorScreen from './screens/ErrorScreen'
import LoadingScreen from './screens/LoadingScreen';
import Grid from '@material-ui/core/Grid';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";

const App = () => {

  const routes = [
    {
      path: "/error",
      component: ErrorScreen
    },
    {
      path: "/success",
      component: SuccessScreen
    },
  ];

  return (
    <Grid container justify="center">
      <Router>
        <Switch>
        {routes.map(route => (
          <Route {...route} />
          ))}
          <Route path="/" exact component={FirstScreen}/>
          <Redirect to="/" />
        </Switch>
      </Router>
    </Grid>
  )
};

export default App;